import phoenix from '../images/phoenix.jpg'
import phoenix2 from '../images/phoenix2.jpg'
import groot from '../images/groot.jpg'
import hummingBird from '../images/humming-bird.jpg'
import fist from '../images/fist.jpg'
import committed from '../images/committed.jpeg'
import fof from '../images/FoF.jpeg'

export const paintingData = [
  {
    name: "scorpion, eagle, phoenix",
    image: phoenix,
    about: "free hand. transparent paint on 4 small plastic frames. splattered spray paint on cardboard backing. fabric paint for character outline / paint containment"
  },
  {
    name: "scorpion, eagle, phoenix, soulite",
    image: phoenix2,
    about: "free hand. acrylic paint brushed on large wood panel with spray painted background."
  },
  {
    name: "halloween groot",
    image: groot,
    about: "free-hand. acrylic paint brushed on cotton leaf-print sheet."
  },
  {
    name: "humming bird",
    image: hummingBird,
    about: "free-hand. spray painted and paint brushed hummingbird on canvas. spray painted leaves from stencils."
  },
  {
    name: "fist from ground",
    image: fist,
    about: "free-hand. transparent paint on canvas. sterilized soil on sealer."
  },
  {
    name: "the committed",
    image: committed,
    about: "free-hand. oil painting on canvas. cover art for 'The Committed' musical works."
  },
  {
    name: "fight or flight",
    image: fof,
    about: "free-hand. spray painted and paint brushed on cardboard. cover art for 'The Fight or Flight Project' musical works."
  },
]